const APP_ENV = import.meta.env.VITE_APP_ENV.toUpperCase();

export type LinkType = {
  PROD: string;
  PREPROD: string;
  DEV: string;
  LOCAL: string;
};

export const getLinkByEnv = (link: LinkType) => {
  switch (APP_ENV) {
    case 'PROD':
      return link.PROD;
    case 'PREPROD':
      return link.PREPROD;
    case 'DEV':
      return link.DEV;
    case 'LOCAL':
      return link.LOCAL;
    default:
      return link.DEV;
  }
};
